import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const sections = [
  {
    title: 'General',
    shortcuts: [
      { keys: ['?'], desc: 'Ayuda de atajos' },
      { keys: ['/'], desc: 'Buscar' },
      { keys: ['c'], desc: 'Cambiar empresa' },
      { keys: ['Esc'], desc: 'Cerrar / Deseleccionar' },
    ],
  },
  {
    title: 'Lista de Tickets',
    shortcuts: [
      { keys: ['j'], desc: 'Siguiente ticket' },
      { keys: ['k'], desc: 'Anterior ticket' },
      { keys: ['o'], desc: 'Abrir ticket' },
      { keys: ['x'], desc: 'Seleccionar ticket' },
      { keys: ['#'], desc: 'Eliminar ticket' },
      { keys: ['s'], desc: 'Cambiar estado...' },
      { keys: ['p'], desc: 'Cambiar prioridad...' },
      { keys: ['a'], desc: 'Asignar agente...' },
    ],
  },
  {
    title: 'Detalle de Ticket',
    shortcuts: [
      { keys: ['r'], desc: 'Responder' },
      { keys: ['n'], desc: 'Nota interna' },
      { keys: ['e'], desc: 'Editar asunto' },
      { keys: ['s'], desc: 'Cambiar estado...' },
      { keys: ['p'], desc: 'Cambiar prioridad...' },
      { keys: ['a'], desc: 'Asignar agente' },
      { keys: ['←'], desc: 'Volver a la lista' },
    ],
  },
  {
    title: 'Secuencias',
    shortcuts: [
      { keys: ['s', '1'], desc: 'Abierto' },
      { keys: ['s', '2'], desc: 'Pendiente' },
      { keys: ['s', '3'], desc: 'Resuelto' },
      { keys: ['s', '4'], desc: 'Cerrado' },
      { keys: ['p', '1'], desc: 'Baja' },
      { keys: ['p', '2'], desc: 'Normal' },
      { keys: ['p', '3'], desc: 'Alta' },
    ],
  },
];

export default function KeyboardShortcutsHelp({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (e.key === 'Escape') { e.stopPropagation(); onClose(); }
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="kb-help-overlay" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className="kb-help-modal">
        <div className="kb-help-header">
          <h3>Atajos de Teclado</h3>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="kb-help-grid">
          {sections.map(section => (
            <div key={section.title} className="kb-help-section">
              <div className="kb-help-section-title">{section.title}</div>
              {section.shortcuts.map((sc, i) => (
                <div key={i} className="kb-help-row">
                  <span className="kb-help-keys">
                    {sc.keys.map((k, j) => (
                      <span key={j}>
                        {j > 0 && <span className="kb-help-then">→</span>}
                        <kbd>{k}</kbd>
                      </span>
                    ))}
                  </span>
                  <span className="kb-help-desc">{sc.desc}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
